import React, { useEffect, useRef } from 'react';
import './Home.css';

const Home = () => {
  const profileNameRef = useRef(null);
  const profileImgRef = useRef(null);

  useEffect(() => {
    // Typing effect for profile name
    if (profileNameRef.current) {
      const originalText = profileNameRef.current.textContent;
      profileNameRef.current.textContent = '';
      
      let i = 0;
      const typeWriter = function() {
        if (i < originalText.length) {
          profileNameRef.current.textContent += originalText.charAt(i);
          i++;
          setTimeout(typeWriter, 100);
        }
      };
      
      setTimeout(typeWriter, 500);
    }

    // Parallax effect for profile image
    const handleScroll = () => {
      if (profileImgRef.current) {
        const scrolled = window.pageYOffset;
        const rate = scrolled * -0.5;
        profileImgRef.current.style.transform = `translateY(${rate}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Ripple effect for social links
  const createRipple = (event) => {
    const button = event.currentTarget;
    const ripple = document.createElement('span');
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;
    
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    ripple.classList.add('ripple');
    
    button.appendChild(ripple);
    
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  const newsItems = [
    {
      text: "I'm graduated Master degree from University of Information Technology, Vietnam National University, Ho Chi Minh City with a Master's degree in Computer Science.",
      link: "https://www.uit.edu.vn/tran-vinh-khiem-tan-thac-si-khoa-hoc-may-tinh-tu-mo-den-dam-me-nghien-cuu"
    },
    {
      text: "Our publication I work with my undergraduate students is published and available on IEEE Explore .",
      link: "https://ieeexplore.ieee.org/abstract/document/11009025/"
    },
    {
      text: "I have defensed my Master's thesis on Vietnamese Visual Question Answering with a score of 9.2/10.",
      link: "#"
    },
  ];

  return (
    <main className="main">
      <div className="container">
        <div className="profile-section">
          <div className="profile-image">
            <img 
              ref={profileImgRef}
              src="./vinhkhiem_picture_picture.jpg"
              alt="Khiem Vinh Tran" 
              className="profile-img"
            />
          </div>
          <div className="profile-info">
            <h1 ref={profileNameRef} className="profile-name">Khiem Vinh Tran</h1>
            <p className="profile-title">Research Staff Member & Associate Lecturer</p>
            <p className="profile-department">Faculty of Information System & Information System Laboratory</p>
            <p className="profile-university">University of Information Technology, Vietnam National University, Ho Chi Minh City</p>
            
            <div className="profile-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>
                <a href="https://maps.app.goo.gl/zVvn2fYphGEJXVRF7" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: '#007bff' }}>
                  Room E9.1, UIT-VNUHCM, Quarter 6, Linh Trung, Thu Duc City
                </a>
              </span>
            </div>

            <div className="social-links">
              <a href="mailto:khiemtv@uit.edu.vn" className="social-link email" onClick={createRipple}>
                <i className="fas fa-envelope"></i>
                <span>Email</span>
              </a>
              <a href="https://scholar.google.com.vn/citations?user=XT2PrJQAAAAJ&hl=vi" className="social-link scholar" onClick={createRipple}>
                <i className="fas fa-graduation-cap"></i>
                <span>Google Scholar</span>
              </a>
              <a href="https://orcid.org/0000-0001-7128-2058" className="social-link orcid" onClick={createRipple}>
                <i className="fab fa-orcid"></i>
                <span>ORCID</span>
              </a>
              <a href="https://www.linkedin.com/in/khiem-tran-vinh/" className="social-link flickr" onClick={createRipple}>
                <i className="fab fa-linkedin"></i>
                <span>LinkedIn</span>
              </a>
              <a href="https://www.instagram.com/kvt0012/" className="social-link instagram" onClick={createRipple}>
                <i className="fab fa-instagram"></i>
                <span>Instagram</span>
              </a>
             
             
             
            </div>
          </div>
        </div>

        <div className="content-section">
          <div className="research-intro">
          <p>
          I am Trần Vĩnh Khiêm, holding a Bachelor of Engineering degree in Information Systems and a Master's degree in Computer Science from the University of Information Technology (UIT), Vietnam National University-Ho Chi Minh City (VNU-HCM). My academic specialization centers on Natural Language Processing (NLP), which represents a crucial subdomain within Artificial Intelligence that focuses on creating computational frameworks capable of interpreting and processing human language.
          </p>
          
          <p>
          The field of NLP encompasses numerous practical applications that have become integral to modern digital experiences. These include sophisticated machine translation platforms such as Google Translate and intelligent conversational agents like Siri (Apple), Yoyo (Honor), Gemini (Google)...
          </p>
          
          <p>
          My research portfolio demonstrates a multidisciplinary approach, spanning several interconnected areas including multimodal artificial intelligence, Vietnamese visual question answering systems, machine reading comprehension for healthcare applications, COVID-19 misinformation detection on social media platforms, and the development of knowledge base question answering systems.
          </p>
          
          <p>
          While these research domains may appear diverse, they are fundamentally unified by two core computational interests: language modeling and multimodal fusion. Language modeling involves developing statistical and probabilistic techniques to understand and predict natural language patterns, while multimodal fusion focuses on integrating information from multiple data sources such as text, images, and audio to create more comprehensive and accurate AI systems. This interdisciplinary approach allows for the development of more robust and contextually aware natural language processing solutions that can better serve real-world applications across various domains.
          </p>
            
            <p><strong>Affiliations</strong>:  <a href="https://nlp.uit.edu.vn/" className="research-link"> The UIT Natural Language Processing Group</a></p>
          </div>

          <section className="section">
            <h3 className="section-title">Prospective Students</h3>
            <ul className="section-list">
              <li>If you are interested in collaborating or discussing research opportunities related to Vietnamese natural language processing and multimodal artificial intelligence, it would help to: (1) have a look over my publications to identify areas of overlapping interests, particularly in Vietnamese visual question answering, multimodal fusion models, or machine reading comprehension; and (2) send a thoughtful research proposal to suggest potential collaborative projects. As I am currently pursuing my undergraduate studies, I don't expect that you have extensive knowledge of the specific challenges in Vietnamese language processing or can immediately develop research questions that fit the scope of complex multimodal AI research, but this proposal would serve as a foundation to explore potential project ideas and learning opportunities within our academic community at UIT. Through these collaborative discussions, we can identify research areas that align with undergraduate capabilities while still contributing meaningfully to the field of natural language processing and Vietnamese language technology development.
              </li>
            </ul>
          </section>
          <section className="section">
            <h3 className="section-title">News</h3>
            <ul className="news-list">
              {newsItems.map((item, index) => (
                <li key={index} className="news-item">
                  {item.link ? (
                    <a href={item.link} className="news-link" target="_blank" rel="noopener noreferrer">
                      {item.text}
                    </a>
                  ) : (
                    item.text
                  )}
                </li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </main>
  );
};

export default Home; 